import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import SideBar from '../../organisms/dossier/SideBar';
import Tabs from '../../organisms/dossier/Tabs';
import Messages from '../../organisms/dossier/timeline/Messages';
import Filters from '../../organisms/dossier/timeline/Filters';
import Flex from '../../atoms/Flex';
import TimelineProgress from '../../organisms/timeline/TimelineProgress';
import { indexOf } from 'lodash';
import Notice from '../../molecules/Notice';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
const Index = ({ history, dossier_number: dossierNumber, dossier: dossier, notice, }) => {
    const { t } = useTranslation();
    const [currentDate, setCurrentDate] = useState('');
    const [filters, setFilters] = useState([]);
    const dateItems = useMemo(() => {
        return history
            .reduce((acc, val) => acc.concat(val.lines), [])
            .map(line => line.date);
    }, [history]);
    const availableFilters = useMemo(() => {
        return history
            .reduce((acc, val) => acc.concat(val.lines), [])
            .map(line => line.type)
            .filter((type, index, self) => {
            return self.indexOf(type) === index;
        });
    }, [history]);
    const handleFilterChange = (e) => {
        if (e.currentTarget.checked) {
            setFilters([...filters, e.currentTarget.id]);
        }
        else {
            const newFilters = [...filters];
            newFilters.splice(indexOf(filters, e.currentTarget.id), 1);
            setFilters(newFilters);
        }
    };
    return (_jsxs(Layout, { dossierNumber: dossierNumber, "data-testid": "dossier-index", children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Tijdlijn - ", t('dossier.title')] }) }), _jsxs(H1, { "data-testid": "title", children: [t('dossier.title'), " ", dossierNumber] }), notice && _jsx(Notice, { ...notice }), _jsxs(Row, { children: [_jsx(Col, { sm: 9, children: _jsxs(Panel, { children: [_jsx(Tabs, { dossier: dossier }), availableFilters.length > 0 && (_jsx(Filters, { filters: availableFilters, onChange: handleFilterChange })), dateItems.length > 0 ? (_jsxs(Flex, { children: [_jsx(TimelineProgress, { from: dateItems[dateItems.length - 1], to: dateItems[0], current: currentDate }), _jsx(Messages, { history: history, filters: filters, onScroll: setCurrentDate })] })) : (_jsx(Notice, { type: "info", title: "Geen tijdlijn beschikbaar" }))] }) }), _jsx(Col, { sm: 3, children: _jsx(SideBar, { dossier: dossier }) })] })] }));
};
export default Index;
